import { ThemeProvider, createTheme } from '@mui/material';
import { FC, ReactNode } from 'react';

const Theme: FC<{ children: ReactNode }> = ({ children }: { children: ReactNode }) => {
    const theme = createTheme({
        palette: {
            primary: {
                main: '#BAA7D8',
                light: '#A588D2',
                dark: '#A588D2'
            }
        },
        components: {
            MuiCheckbox: {
                styleOverrides: {
                    root: {
                        color: 'rgba(186, 167, 216, 1) !important'
                    }
                }
            }
        }
    });

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
